import includes from 'lodash/includes';
import { DEFAULT_LABEL, FETCH_LIST_START, FETCH_LIST_SUCCESS, FETCH_LIST_FAILURE, FETCH_ONE_START, FETCH_ONE_SUCCESS, FETCH_ONE_FAILURE, CREATE_ONE_START, CREATE_ONE_SUCCESS, CREATE_ONE_FAILURE, UPDATE_ONE_START, UPDATE_ONE_SUCCESS, UPDATE_ONE_FAILURE, PATCH_ONE_START, PATCH_ONE_SUCCESS, PATCH_ONE_FAILURE, DELETE_ONE_START, DELETE_ONE_SUCCESS, DELETE_ONE_FAILURE, HEAD_START, HEAD_SUCCESS, HEAD_FAILURE, POST_START, POST_SUCCESS, POST_FAILURE, PUT_START, PUT_SUCCESS, PUT_FAILURE, PATCH_START, PATCH_SUCCESS, PATCH_FAILURE, INVALIDATE, DELETE_SUCCESS, DELETE_FAILURE, DELETE_START, INVALIDATE_FAILURES } from './constants';
import { removeOne, appendOne, matches } from './helpers';
const DEFAULT_RESOURCE_STATE = {
  isLoaded: [],
  isFailure: [],
  isFetching: [],
  isToRefetch: [],
  isLoadedOne: [],
  isFailureOne: [],
  isFetchingOne: [],
  isToRefetchOne: [],
  isCreatingOne: [],
  isUpdatingOne: [],
  isPatchingOne: [],
  isDeletingOne: [],
  isPosting: [],
  isPutting: [],
  isPatching: [],
  isDeleting: [],
  isHeading: [],
  isHeadFailure: []
};
const updateStateForResource = (resource, oldState, newResourceState) => {
  const resourceOldState = oldState[resource] || DEFAULT_RESOURCE_STATE;
  return {
    ...oldState,
    [resource]: {
      ...resourceOldState,
      ...(typeof newResourceState === 'function' ? newResourceState(resourceOldState) : newResourceState)
    }
  };
};
const frozenEmptyObj = Object.freeze({});
const invalidateFailuresNewState = (curr, statusName, retryableFailures) => ({
  isToRefetch: statusName === 'isFailure' ? [...new Set([...curr.isToRefetch, ...retryableFailures])] : curr.isToRefetch,
  isToRefetchOne: statusName === 'isFailureOne' ? [...new Set([...curr.isToRefetchOne, ...retryableFailures])] : curr.isToRefetchOne
});
function invalidateFailuresReducer(state, action) {
  let newState = state;
  Object.entries(state).forEach(([resourceName, resourceState]) => {
    Object.entries(resourceState).forEach(([statusName, labels]) => {
      if (statusName !== 'isFailure' && statusName !== 'isFailureOne') return;
      let failureStates = labels;
      if (!failureStates.length) return;
      if (typeof action.payload.status === 'number') {
        failureStates = failureStates.filter(label => label.status === action.payload.status);
      }
      newState = updateStateForResource(resourceName, newState, invalidateFailuresNewState(resourceState, statusName, failureStates.map(resource => resource.label)));
    });
  });
  return newState;
}
export default (state = {}, action) => {
  if (!action || !action.meta || !action.meta.type) {
    return state;
  }
  if (action.meta.type === INVALIDATE_FAILURES) {
    return invalidateFailuresReducer(state, action);
  }
  if (!action.meta.resource) {
    return state;
  }
  const responseStatus = action.payload.error && typeof action.payload.error !== 'function' && action.payload.error.response ? action.payload.error.response.status : null;
  const resourceName = action.meta.resource;
  const label = action.meta.label;
  switch (action.meta.type) {
    case FETCH_LIST_START:
      return updateStateForResource(resourceName, state, curr => ({
        isFetching: appendOne(curr.isFetching, label)
      }));
    case FETCH_LIST_SUCCESS:
      return updateStateForResource(resourceName, state, curr => ({
        isFetching: removeOne(curr.isFetching, label),
        isLoaded: includes(curr.isLoaded, label) ? curr.isLoaded : appendOne(curr.isLoaded, label),
        isFailure: removeOne(curr.isFailure, {
          label
        }),
        isToRefetch: removeOne(curr.isToRefetch, label)
      }));
    case FETCH_LIST_FAILURE:
      return updateStateForResource(resourceName, state, curr => ({
        isFetching: removeOne(curr.isFetching, label),
        isFailure: matches(curr.isFailure, {
          label
        }) ? curr.isFailure : appendOne(curr.isFailure, {
          label,
          ...(responseStatus ? {
            status: responseStatus
          } : frozenEmptyObj)
        }),
        isToRefetch: removeOne(curr.isToRefetch, label)
      }));
    case FETCH_ONE_START:
      return updateStateForResource(resourceName, state, curr => ({
        isFetchingOne: appendOne(curr.isFetchingOne, label)
      }));
    case FETCH_ONE_SUCCESS:
      return updateStateForResource(resourceName, state, curr => ({
        isFetchingOne: removeOne(curr.isFetchingOne, label),
        isLoadedOne: includes(curr.isLoadedOne, label) ? curr.isLoadedOne : appendOne(curr.isLoadedOne, label),
        isFailureOne: removeOne(curr.isFailureOne, {
          label
        }),
        isToRefetchOne: removeOne(curr.isToRefetchOne, label)
      }));
    case FETCH_ONE_FAILURE:
      return updateStateForResource(resourceName, state, curr => ({
        isFetchingOne: removeOne(curr.isFetchingOne, label),
        isFailureOne: matches(curr.isFailureOne, {
          label
        }) ? curr.isFailureOne : appendOne(curr.isFailureOne, {
          label,
          ...(responseStatus ? {
            status: responseStatus
          } : frozenEmptyObj)
        }),
        isToRefetchOne: removeOne(curr.isToRefetchOne, label)
      }));
    case CREATE_ONE_START:
      return updateStateForResource(resourceName, state, curr => ({
        isCreatingOne: appendOne(curr.isCreatingOne, label)
      }));
    case CREATE_ONE_SUCCESS:
    case CREATE_ONE_FAILURE:
      return updateStateForResource(resourceName, state, curr => ({
        isCreatingOne: removeOne(curr.isCreatingOne, label)
      }));
    case UPDATE_ONE_START:
      return updateStateForResource(resourceName, state, curr => ({
        isUpdatingOne: appendOne(curr.isUpdatingOne, label)
      }));
    case UPDATE_ONE_SUCCESS:
    case UPDATE_ONE_FAILURE:
      return updateStateForResource(resourceName, state, curr => ({
        isUpdatingOne: removeOne(curr.isUpdatingOne, label)
      }));
    case PATCH_ONE_START:
      return updateStateForResource(resourceName, state, curr => ({
        isPatchingOne: appendOne(curr.isPatchingOne, label)
      }));
    case PATCH_ONE_SUCCESS:
    case PATCH_ONE_FAILURE:
      return updateStateForResource(resourceName, state, curr => ({
        isPatchingOne: removeOne(curr.isPatchingOne, label)
      }));
    case POST_START:
      return updateStateForResource(resourceName, state, curr => ({
        isPosting: appendOne(curr.isPosting, label)
      }));
    case POST_SUCCESS:
    case POST_FAILURE:
      return updateStateForResource(resourceName, state, curr => ({
        isPosting: removeOne(curr.isPosting, label)
      }));
    case PUT_START:
      return updateStateForResource(resourceName, state, curr => ({
        isPutting: appendOne(curr.isPutting, label)
      }));
    case PUT_SUCCESS:
    case PUT_FAILURE:
      return updateStateForResource(resourceName, state, curr => ({
        isPutting: removeOne(curr.isPutting, label)
      }));
    case PATCH_START:
      return updateStateForResource(resourceName, state, curr => ({
        isPatching: appendOne(curr.isPatching, label)
      }));
    case PATCH_SUCCESS:
    case PATCH_FAILURE:
      return updateStateForResource(resourceName, state, curr => ({
        isPatching: removeOne(curr.isPatching, label)
      }));
    case HEAD_START:
      return updateStateForResource(resourceName, state, curr => ({
        isHeading: appendOne(curr.isHeading, label)
      }));
    case HEAD_SUCCESS:
      return updateStateForResource(resourceName, state, curr => ({
        isHeading: removeOne(curr.isHeading, label),
        isHeadFailure: matches(curr.isHeadFailure, {
          label
        }) ? removeOne(curr.isHeadFailure, {
          label
        }) : curr.isHeadFailure
      }));
    case HEAD_FAILURE:
      return updateStateForResource(resourceName, state, curr => ({
        isHeadFailure: matches(curr.isHeadFailure, {
          label
        }) ? curr.isHeadFailure : appendOne(curr.isHeadFailure, {
          label,
          ...(responseStatus ? {
            status: responseStatus
          } : frozenEmptyObj)
        }),
        isHeading: removeOne(curr.isHeading, label)
      }));
    case DELETE_ONE_START:
      return updateStateForResource(resourceName, state, curr => ({
        isDeletingOne: appendOne(curr.isDeletingOne, label)
      }));
    case DELETE_ONE_SUCCESS:
    case DELETE_ONE_FAILURE:
      return updateStateForResource(resourceName, state, curr => ({
        isDeletingOne: removeOne(curr.isDeletingOne, label)
      }));
    case DELETE_START:
      return updateStateForResource(resourceName, state, curr => ({
        isDeleting: appendOne(curr.isDeleting, label)
      }));
    case DELETE_SUCCESS:
    case DELETE_FAILURE:
      return updateStateForResource(resourceName, state, curr => ({
        isDeleting: removeOne(curr.isDeleting, label)
      }));
    case INVALIDATE:
      return updateStateForResource(resourceName, state, curr => ({
        isToRefetch: [...new Set([].concat(curr.isToRefetch, curr.isLoaded, curr.isFailure.map(resource => resource.label)))],
        isToRefetchOne: [...new Set([].concat(curr.isToRefetchOne, curr.isLoadedOne, curr.isFailureOne.map(resource => resource.label)))]
      }));
    default:
      return state;
  }
};
const EMPTY_OBJECT = {};
const selectRaw = state => state.gandiReduxResource || EMPTY_OBJECT;
const selectRawResource = (state, resourceName) => selectRaw(state)[resourceName] || DEFAULT_RESOURCE_STATE;
export const selectIsLoadedResource = (state, {
  resource,
  label = DEFAULT_LABEL
}) => includes(selectRawResource(state, resource).isLoaded, label);
export const selectIsFailureResource = (state, {
  resource,
  label = DEFAULT_LABEL,
  status
}) => matches(selectRawResource(state, resource).isFailure, {
  label,
  status
});
export const selectIsFetchingResource = (state, {
  resource,
  label = DEFAULT_LABEL
}) => includes(selectRawResource(state, resource).isFetching, label);
export const selectIsToRefetchResource = (state, {
  resource,
  label = DEFAULT_LABEL
}) => includes(selectRawResource(state, resource).isToRefetch, label);
export const selectIsLoadedOneResource = (state, {
  resource,
  label = DEFAULT_LABEL
}) => includes(selectRawResource(state, resource).isLoadedOne, label);
export const selectIsFailureOneResource = (state, {
  resource,
  label = DEFAULT_LABEL,
  status
}) => matches(selectRawResource(state, resource).isFailureOne, {
  label,
  status
});
export const selectIsFetchingOneResource = (state, {
  resource,
  label = DEFAULT_LABEL
}) => includes(selectRawResource(state, resource).isFetchingOne, label);
export const selectIsToRefetchOneResource = (state, {
  resource,
  label = DEFAULT_LABEL
}) => includes(selectRawResource(state, resource).isToRefetchOne, label);
export const selectIsCreatingOneResource = (state, {
  resource,
  label = DEFAULT_LABEL
}) => includes(selectRawResource(state, resource).isCreatingOne, label);
export const selectIsUpdatingOneResource = (state, {
  resource,
  label = DEFAULT_LABEL
}) => includes(selectRawResource(state, resource).isUpdatingOne, label);
export const selectIsPatchingOneResource = (state, {
  resource,
  label = DEFAULT_LABEL
}) => includes(selectRawResource(state, resource).isPatchingOne, label);
export const selectIsDeletingOneResource = (state, {
  resource,
  label = DEFAULT_LABEL
}) => includes(selectRawResource(state, resource).isDeletingOne, label);
export const selectIsHeadingResource = (state, {
  resource,
  label = DEFAULT_LABEL
}) => includes(selectRawResource(state, resource).isHeading, label);
export const selectIsHeadFailureResource = (state, {
  resource,
  label = DEFAULT_LABEL
}) => matches(selectRawResource(state, resource).isHeadFailure, {
  label
});
export const selectIsPostingResource = (state, {
  resource,
  label = DEFAULT_LABEL
}) => includes(selectRawResource(state, resource).isPosting, label);
export const selectIsPuttingResource = (state, {
  resource,
  label = DEFAULT_LABEL
}) => includes(selectRawResource(state, resource).isPutting, label);
export const selectIsPatchingResource = (state, {
  resource,
  label = DEFAULT_LABEL
}) => includes(selectRawResource(state, resource).isPatching, label);
export const selectIsDeletingResource = (state, {
  resource,
  label = DEFAULT_LABEL
}) => includes(selectRawResource(state, resource).isDeleting, label);
export const selectShouldFetch = (state, options) => {
  const isLoaded = selectIsLoadedResource(state, options);
  const isFailure = selectIsFailureResource(state, options);
  const isToRefetch = selectIsToRefetchResource(state, options);
  const isFetching = selectIsFetchingResource(state, options);
  return (!isLoaded && !isFailure || isToRefetch) && !isFetching;
};
export const selectShouldFetchOne = (state, options) => {
  const isLoaded = selectIsLoadedOneResource(state, options);
  const isFailure = selectIsFailureOneResource(state, options);
  const isToRefetch = selectIsToRefetchOneResource(state, options);
  const isFetching = selectIsFetchingOneResource(state, options);
  return (!isLoaded && !isFailure || isToRefetch) && !isFetching;
};